import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout, EmbedLayout } from '@/components/layout';
import { ProtectedRoute } from './protected-route';
import {
  DashboardPage,
  DIDsPage,
  DIDSearchPage,
  E911Page,
  PortingPage,
  OrdersPage,
  OrderHistoryPage,
  UsagePage,
  LoginPage,
} from '../pages';

// Layout wrapper for protected routes with MainLayout
function ProtectedMainLayout() {
  return (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  );
}

// Layout wrapper for protected routes with EmbedLayout
function ProtectedEmbedLayout() {
  return (
    <ProtectedRoute>
      <EmbedLayout />
    </ProtectedRoute>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Full portal routes (with MainLayout) */}
      <Route element={<ProtectedMainLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/dids" element={<DIDsPage />} />
        <Route path="/dids/search" element={<DIDSearchPage />} />
        <Route path="/911" element={<E911Page />} />
        <Route path="/porting" element={<PortingPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/order-history" element={<OrderHistoryPage />} />
        <Route path="/usage" element={<UsagePage />} />
      </Route>

      {/* Embed routes (minimal UI for iframe) */}
      <Route path="/embed" element={<ProtectedEmbedLayout />}>
        <Route index element={<Navigate to="/embed/dids" replace />} />
        <Route path="dids" element={<DIDsPage />} />
        <Route path="dids/search" element={<DIDSearchPage />} />
        <Route path="911" element={<E911Page />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
